import { InjectionToken } from '@angular/core';

/**
 * Injection token for the API base URL
 * Used by services to make HTTP requests to the backend API
 */
export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

/**
 * Injection token for the enrollment portal base URL.
 * Local:  https://localhost:4200
 * Test:   https://enrollment.test.legalresources.com
 * Prod:   https://enrollment.legalresources.com
 */
export const ENROLLMENT_BASE_URL = new InjectionToken<string>('ENROLLMENT_BASE_URL');
